module.exports = __webpack_public_path__ + "img/icon_map_108_on_001.45d925cb.png";